import { cn as e } from "../../lib/utils.js";
import { COMPONENT_SIZES as t } from "../../shared/component-sizes.js";
import n from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/core/icon/material-icon.tsx
var i = {
	xs: t.xs.iconSize,
	sm: t.sm.iconSize,
	default: t.default.iconSize,
	lg: t.lg.iconSize
}, a = n.forwardRef(({ name: t, className: n, size: a = "default", fill: o = 0, ...s }, c) => {
	let l = i[a], u = {
		fontFamily: "'Material Symbols Rounded'",
		fontSize: l,
		fontVariationSettings: `'FILL' ${o}, 'wght' 300, 'GRAD' 0, 'opsz' 24`,
		userSelect: "none",
		width: l,
		height: l,
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		lineHeight: 1
	};
	return /* @__PURE__ */ r("span", {
		ref: c,
		className: e("material-symbols-rounded", n),
		style: u,
		"aria-hidden": !s["aria-label"] || void 0,
		...s,
		children: t
	});
});
a.displayName = "MaterialIcon";
//#endregion
export { a as MaterialIcon, i as SIZE_MAP };
